import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20251223_elevation_entity_tag",
  description: "Add elevation entity tag to elevation annotations",
  apply(json: any): any {
    const entityTags = json.entityTags;
    if (!entityTags.addToExteriorElevation) {
      entityTags.addToExteriorElevation = {
        entityType: "ENTITY_TAG",
        id: "addToExteriorElevation",
        name: "Add to Exterior Elevation",
        sortIndex: 0,
      };
    }
    if (!entityTags.addToPerspectiveView) {
      entityTags.addToPerspectiveView = {
        entityType: "ENTITY_TAG",
        id: "addToPerspectiveView",
        name: "Add to Perspective View",
        sortIndex: 0,
      };
    }
    const annotationTable = json.annotation;
    const elevationViews = json.elevationViews;
    const propAttributes = json.propAttributes ?? {};
    for (const id of Object.keys(annotationTable)) {
      const annotation = annotationTable[id];
      if (annotation.parentId && elevationViews[annotation.parentId]) {
        annotation.tags = { ...annotation.tags, addToExteriorElevation: true };
      }
    }
    for (const viewId of Object.keys(elevationViews)) {
      const view = elevationViews[viewId];
      if (view.viewFilter) {
        view.viewFilter.tags = { ...view.viewFilter.tags, addToExteriorElevation: true };
      }
    }
    // Note that we intentionally don't add the "perspective" tag to view3Ds here, since that tag is intended to filter linework views, not realistic style views.
    for (const propAttributeId of Object.keys(propAttributes)) {
      const prop = propAttributes[propAttributeId];
      if (prop.showOnElevationsAndPerspectives) {
        prop.tags = { ...prop.tags, addToExteriorElevation: true, addToPerspectiveView: true };
      }
      delete prop.showOnElevationsAndPerspectives;
    }

    return json;
  },
};

export default migration;
